// Firebase configuration for Love Connect +
import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';
import { BACKEND_URL } from './config';

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDUAPcMToUrcYeUC95vaX4K7by5tw8KTs4",
  authDomain: "love-connect-plus.firebaseapp.com",
  projectId: "love-connect-plus",
  storageBucket: "love-connect-plus.firebasestorage.app",
  messagingSenderId: "493358718174",
  appId: "1:493358718174:web:f86a9442055913ff78b64f",
  measurementId: "G-LHXXFEMCCR"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Analytics (only in browser)
let analytics = null;
if (typeof window !== 'undefined') {
  analytics = getAnalytics(app);
}

// Initialize Cloud Messaging
let messaging = null;
if (typeof window !== 'undefined' && 'Notification' in window) {
  try {
    messaging = getMessaging(app);
  } catch (error) {
    console.log('Firebase Messaging not supported:', error);
  }
}

// VAPID Key for Web Push
const VAPID_KEY = 'BOoSnMKon_MXO3yBX5yaJ5Fln22cAQABJ0GO9BdzXlAUkJ6jXa48BBbPItZjhUYo5xKBx3ATsP_-bosfucIiTrk';

/**
 * Request permission and get FCM token
 * @returns {Promise<string|null>} FCM token or null if denied
 */
export async function requestNotificationPermission() {
  if (!messaging) {
    console.log('Messaging not supported');
    return null;
  }

  try {
    // Request permission
    const permission = await Notification.requestPermission();
    
    if (permission === 'granted') {
      console.log('Notification permission granted');
      
      // Get FCM token
      const token = await getToken(messaging, { 
        vapidKey: VAPID_KEY 
      });
      
      if (token) {
        console.log('FCM Token:', token);
        // Send token to backend to store for this user
        await saveTokenToServer(token);
        return token;
      }
    } else {
      console.log('Notification permission denied');
    }
    
    return null;
  } catch (error) {
    console.error('Error getting notification permission:', error);
    return null;
  }
}

/**
 * Save FCM token to backend
 */
async function saveTokenToServer(token) {
  try {
    const sessionToken = localStorage.getItem('session_token');
    if (!sessionToken) return;

    await fetch(`${BACKEND_URL}/api/users/fcm-token`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${sessionToken}`
      },
      body: JSON.stringify({ fcm_token: token })
    });
    
    console.log('FCM token saved to server');
  } catch (error) {
    console.error('Error saving FCM token:', error);
  }
}

/**
 * Listen for foreground messages
 */
export function onForegroundMessage(callback) {
  if (!messaging) return () => {};
  
  return onMessage(messaging, (payload) => {
    console.log('Foreground message received:', payload);
    
    // Show notification manually since we're in foreground
    if (payload.notification) {
      const { title, body, icon } = payload.notification;
      
      // Create a custom notification
      if (Notification.permission === 'granted') {
        new Notification(title, {
          body,
          icon: icon || '/icons/icon-192x192.png',
          badge: '/icons/icon-72x72.png',
          tag: payload.data?.type || 'default',
          data: payload.data
        });
      }
      
      // Call the callback for in-app handling
      if (callback) {
        callback(payload);
      }
    }
  });
}

/**
 * Check if notifications are supported and enabled
 */
export function isNotificationSupported() {
  return 'Notification' in window && 'serviceWorker' in navigator;
}

/**
 * Get current notification permission status
 */
export function getNotificationPermissionStatus() {
  if (!isNotificationSupported()) return 'unsupported';
  return Notification.permission; // 'granted', 'denied', 'default'
}

// Export Firebase instances
export { app, analytics, messaging };
